export const rateLimitMessage = (unit) => {
  if (unit === 'minute') {
    return 'Xero rate limit exceeded. Please wait a minute and try again.'
  }
  if (unit === 'day') {
    return 'Daily Xero rate limit exceeded. Please wait awhile and try again.'
  }
  return 'Xero rate limit exceeded.'
}
